import { Link } from 'react-router-dom';
import suitupLogo from '../assets/suitup-logo.png';

const DeleteAccount = () => (
  <main className="min-h-screen px-4 py-12">
    <div className="mx-auto max-w-xl rounded-lg bg-white p-6 shadow sm:p-8">
      <img src={suitupLogo} alt="SuitUp" className="mx-auto mb-6 h-16 w-auto" />
      <h1 className="text-2xl font-bold text-gray-900">מחיקת חשבון SuitUp</h1>
      <p className="mt-4 text-gray-700">
        לאחר ההתחברות, יש להיכנס לפרופיל האישי ולבחור „מחיקת החשבון שלי”. המחיקה קבועה
        וכוללת את החשבון, הפרופיל, קורות החיים והמועמדויות.
      </p>
      <div className="mt-6 flex flex-col gap-3 sm:flex-row">
        <Link to="/login" className="btn-primary text-center">התחברות ומחיקה</Link>
        <a
          href="https://suitup.co.il/contact_us"
          target="_blank"
          rel="noreferrer"
          className="btn-secondary text-center"
        >
          בקשת מחיקה ללא גישה לחשבון
        </a>
      </div>
      <p className="mt-4 text-sm text-gray-600">
        בפנייה יש לציין „מחיקת חשבון” ואת האימייל או מספר הטלפון ששימשו להרשמה, כדי שנוכל לאמת את הבקשה.
      </p>
    </div>
  </main>
);

export default DeleteAccount;
